import React, { useEffect, useMemo, useState } from 'react';

const FEEDS = [
  { type: 'video', label: 'NASA TV', url: 'https://www.youtube.com/embed/21X5lGlDOfg?autoplay=0' },
  { type: 'video', label: 'SpaceX Live', url: 'https://www.youtube.com/embed/wwMDvPCGeE0?autoplay=0' },
  { type: 'video', label: 'Weather Channel Live', url: 'https://www.youtube.com/embed/9Auq9mYxFEE?autoplay=0' },
  { type: 'image', label: 'NOAA GOES East', url: 'https://cdn.star.nesdis.noaa.gov/GOES16/ABI/SECTOR/taw/GEOCOLOR/latest.jpg' },
  { type: 'image', label: 'NASA EPIC Earth', url: 'https://epic.gsfc.nasa.gov/archive/natural/latest.jpg' },
];
const FEED_TIMEOUT_MS = 12000;

export default function LiveFeeds() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [failed, setFailed] = useState({});

  const active = FEEDS[activeIndex];

  const allFailed = useMemo(
    () => FEEDS.every((_, idx) => Boolean(failed[idx])),
    [failed]
  );

  const shiftToNextFeed = (failedMap = failed, fromIndex = activeIndex) => {
    if (FEEDS.every((_, idx) => Boolean(failedMap[idx]))) return;
    for (let offset = 1; offset <= FEEDS.length; offset += 1) {
      const nextIndex = (fromIndex + offset) % FEEDS.length;
      if (!failedMap[nextIndex]) {
        setActiveIndex(nextIndex);
        return;
      }
    }
  };

  const markFailedAndRotate = (idx = activeIndex) => {
    setFailed((prev) => {
      const nextFailed = { ...prev, [idx]: true };
      shiftToNextFeed(nextFailed, idx);
      return nextFailed;
    });
  };

  useEffect(() => {
    if (allFailed) return undefined;
    const timer = setTimeout(() => {
      markFailedAndRotate(activeIndex);
    }, FEED_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [activeIndex, allFailed]);

  return (
    <div className="orion-livefeeds-wrap" data-testid="orion-livefeeds">
      <div className="orion-livefeeds-header">
        <div className="orion-livefeeds-title">LIVE FEEDS</div>
        <div className="orion-livefeeds-sub">Auto-fallback + timeout rotation enabled</div>
      </div>
      {!allFailed ? (
        <div className="orion-livefeeds-stage" data-testid="orion-livefeeds-frame">
          {active?.type === 'video' ? (
            <iframe
              key={active.url}
              src={active.url}
              title="Orion live feed"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer"
              onLoad={() => setFailed((prev) => ({ ...prev, [activeIndex]: false }))}
              onError={() => markFailedAndRotate(activeIndex)}
            />
          ) : (
            <img
              key={active.url}
              src={active?.url}
              alt="Orion fallback"
              loading="lazy"
              onLoad={() => setFailed((prev) => ({ ...prev, [activeIndex]: false }))}
              onError={() => markFailedAndRotate(activeIndex)}
            />
          )}
          <div className="orion-livefeeds-caption">
            <span>{active?.label || active?.url || 'live source'}</span>
            <button
              type="button"
              className="orion-livefeeds-next"
              onClick={() => shiftToNextFeed()}
            >
              next feed {activeIndex + 1}/{FEEDS.length}
            </button>
          </div>
        </div>
      ) : (
        <div className="orion-livefeeds-fallback" data-testid="orion-livefeeds-fallback">
          Live feeds are temporarily unavailable. Please check back shortly.
        </div>
      )}
    </div>
  );
}
